// extracted by mini-css-extract-plugin
export var content = "_dc-3";
export var list = "_dc-4";
export var settingsContent = "_dc-7";
export var settingsPanel = "_dc-8";
export var state = "_dc-6";
export var triggerBadge = "_dc-2";
export var triggerButton = "_dc-1";
export var triggerShell = "_dc-0";
export var unreadDot = "_dc-5";